import { render } from "./LinkedPagePicker.vue?vue&type=template&id=cf1db0d8"
import script from "./LinkedPagePicker.vue?vue&type=script&lang=js"
export * from "./LinkedPagePicker.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__